import { ErrorHelper } from '@/helpers/ErrorHelper'
import { mapActions, mapState } from 'vuex'

export const ClientOnboardingInviteCacheMixin = {
  data () {
    return {
      error: ''
    }
  },
  computed: {
    ...mapState('ClientOnboardingInvites', [
      'clientOnboardingInvite',
      'loadingClientOnboardingInvite',
      'loadedClientOnboardingInvite'
    ]),
    inviteId () {
      return this.clientOnboardingInvite ? this.clientOnboardingInvite.id : ''
    },
    updatedPets () {
      return this.clientOnboardingInvite ? this.clientOnboardingInvite.updatedPets : []
    },
    updatedPetNotes () {
      return this.clientOnboardingInvite ? this.clientOnboardingInvite.updatedPetNotes : []
    },
    clientDetailsUpdated () {
      return this.clientOnboardingInvite ? this.clientOnboardingInvite.clientDetailsUpdated : false
    },
    clientAddressUpdated () {
      return this.clientOnboardingInvite ? this.clientOnboardingInvite.clientAddressUpdated : false
    },
    clientNoteUpdated () {
      return this.clientOnboardingInvite ? this.clientOnboardingInvite.clientNoteUpdated : false
    },
    petDetailsUpdated () {
      return this.clientOnboardingInvite ? this.clientOnboardingInvite.petDetailsUpdated : false
    },
    petNoteUpdated () {
      return this.clientOnboardingInvite ? this.clientOnboardingInvite.petNoteUpdated : false
    },
    vetContactUpdated () {
      return this.clientOnboardingInvite ? this.clientOnboardingInvite.vetContactUpdated : false
    },
    alternateContactUpdated () {
      return this.clientOnboardingInvite ? this.clientOnboardingInvite.alternateContactUpdated : false
    },
    acceptMarketingUpdated () {
      return this.clientOnboardingInvite ? this.clientOnboardingInvite.acceptMarketingUpdated : false
    },
    contractCompleted () {
      return this.clientOnboardingInvite ? this.clientOnboardingInvite.contractCompleted : false
    },
    allCacheStepsCompleted () {
      return (
        this.clientDetailsUpdated &&
        this.clientAddressUpdated &&
        this.clientNoteUpdated &&
        this.petDetailsUpdated &&
        this.petNoteUpdated &&
        this.vetContactUpdated &&
        this.alternateContactUpdated &&
        this.acceptMarketingUpdated &&
        this.contractCompleted
      )
    }
  },
  watch: {
    inviteId () {
      this.refreshClientOnboardingInvite()
    }
  },
  methods: {
    ...mapActions('ClientOnboardingInvites', [
      'fetchClientOnboardingInvite'
    ]),
    refreshClientOnboardingInvite () {
      if (!this.clientOnboardingInvite || !this.loadingClientOnboardingInvite) {
        this.tryFetchClientOnboardingInvite()
      }
    },
    tryFetchClientOnboardingInvite () {
      const self = this
      if (!self.inviteId || self.loadingClientOnboardingInvite) {
        return
      }
      self.error = ''
      self.fetchClientOnboardingInvite(self.inviteId)
        .catch(error => { self.error = ErrorHelper.getError(error) })
    }
  },
  created () {
    this.refreshClientOnboardingInvite()
  }
}
